export const prohibitedItemListDoc = 'https://docs.google.com/spreadsheets/d/1EJCoh3i8-sZy9nSGh4xxYD458VPD_r2Bn3D4DhBMudE/export?format=pdf'